import React, {useState} from "react";
import {Box, Button, Grid, Typography, TextField, styled} from "@mui/material";
import SubTitle from "../../components/SubTitle";
import MWCaption from "../../components/MWCaption";
import {useNavigate} from "react-router-dom";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import {useRecoilState, useRecoilValue} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {extraAlertStateAtom} from "../../Recoil/Atom/AlertAtom";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseFile} from "../../models/clientModels/interfaces/Response";
import * as manualApi from "../../api/manualApi/manualApi";
import * as Params from "../../models/clientModels/interfaces/apiParams";

const ManageTableContainer = styled(Grid)(({theme}) => ({
  marginTop: "32px",
  alignItems: "center",
  paddingBottom: "32px",
  backgroundColor: theme.palette.background.paper,
}));

const Manual = () => {
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const [extraAlertState, setExtraAlertState] = useRecoilState(extraAlertStateAtom);
  const [fileName, setFileName] = useState<string>("");

  const {mutate: loadMutate, data} = useCreateMutation<ResponseFile, Params.ImportFile>({
    api: manualApi.UploadManual,
    options: {
      onSuccess: (data: ResponseFile) => {
        setExtraAlertState({
          ...extraAlertState,
          title: "사용자 설명서 불러오기",
          toggle: true,
          message: data.extra,
        });
      },
      onError: () => {
        setExtraAlertState({
          ...extraAlertState,
          title: "사용자 설명서 불러오기",
          toggle: true,
          message: data?.extra!,
        });
      },
    },
  });

  return (
    <React.Fragment>
      <SubTitle subTitle="사용자 설명서" />
      <ManageTableContainer container rowSpacing={4}>
        <MWCaption title="사용자 설명서" color="#01579B" icon={<MenuBookIcon />} />
        <Box display="flex" alignItems="center" mt="48px" pl="36px">
          <Button
            variant="contained"
            size="medium"
            component="label"
            color="success"
            sx={{whiteSpace: "nowrap", flexShrink: 0, fontSize: "12px"}}
          >
            사용자 설명서 불러오기
            <TextField
              sx={{display: "none"}}
              onChange={async (event: React.ChangeEvent<HTMLInputElement>) => {
                const convertBase64 = (data: Blob): Promise<any> => {
                  return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(data);
                    reader.onload = () => {
                      resolve(reader.result);
                    };
                    reader.onerror = (error) => {
                      reject(error);
                    };
                  });
                };
                const file = event.target?.files![0];
                const fileName = event.target?.files![0].name;
                const base64 = await convertBase64(file);
                setFileName(fileName);
                loadMutate({token: tokenState, fileName, base64: base64.split(",")[1]});
              }}
              type="file"
              id="base64"
              inputProps={{
                accept:
                  ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
              }}
            />
          </Button>
          <Typography ml="16px">{fileName}</Typography>
        </Box>
      </ManageTableContainer>
      <Box display="flex" justifyContent="center" alignItems="center" padding="24px">
        <Button
          variant="contained"
          color="warning"
          onClick={() => navigate(-1)}
          sx={{color: "white", fontWeight: "700"}}
        >
          뒤로가기
        </Button>
      </Box>
    </React.Fragment>
  );
};

export default Manual;
